{
  "version": 1,
  "asset_id": "a585d3b0-7f58-42e1-9b7c-421fc4f057a2",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a585d3b0-7f58-42e1-9b7c-421fc4f057a2/workspace-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a585d3b0-7f58-42e1-9b7c-421fc4f057a2/workspace-1280.webp",
  "original_filename": "workspace-1280.webp",
  "size": 44974,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:27:05Z"
}
